module.exports = "/images/ie.svg?678a1f6e3ba2d0c1bd65869125b98c5b";